import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import * as api from "../../api";
import HHTableHeader from "../hh/hh-table-header";
import HHTableRow from "../hh/hh-table-row";
import {DateFilter} from "../../components/table/filters/date-filter";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import ReactGA from 'react-ga';
export default class HalfHourMeterTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ApiDataProvider(api.getHalfHourMeterReadings, [this.props.customerId, this.props.siteKey, this.props.meterSiteKey]),
        }
    }
    componentDidMount = () => {
     
        ReactGA.pageview('meter hh tab');
    };

    render() {
        return (
            <div className="main-container">
              
                <Grid padded stackable columns='equal' verticalAlign='middle'>
                   
                      
                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} canExport={true}
                                                     filterComponent={DateFilter} defaultSort={"date"} name="half-hour"
                                                     headerComponent={HHTableHeader} rowComponent={HHTableRow}
                                                     contextData={{ customerId: this.props.customerId }} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}